// @flow
import React from 'react';
import type { CurrentCompetitionsType } from 'types/Settings';

type StateProps = {
  competition: CurrentCompetitionsType,
  isRight?: boolean
};

function EventDrivenPagePromotionalBlockCard({ competition, isRight }: StateProps) {
  const titleOne = competition.home_block_data.title_one;
  const titleTwo = competition.home_block_data.title_two;
  const titleThree = competition.home_block_data.title_three;
  const titleIsCentered = competition.home_block_data.title_is_centered;
  const description = competition.home_block_data.description;
  const link = competition.home_block_data.link;
  const cta = competition.home_block_data.cta;
  const logo = competition.home_block_data.logo;

  return (
    <>
      {/* <div className={`col col-md-6 section-home-worldcup__card ${isRight ? 'right' : 'left'}`}> */}
      <div className={`col col-md-6 section-blueAlt section-home-worldcup__card mb-2 mb-md-0`}>
        {!!logo && (
          <div className="section--logo">
            <img src={logo} />
          </div>
        )}
        <div className="section--link">
          <p>{description}</p>
          <h2 className={!!titleIsCentered ? 'is-centered' : ''}>
            {titleOne.trim() + ' ' + titleTwo.trim() + ' ' + titleThree.trim()}
          </h2>
          <a className="btn--competitions-internationales" href={link}>
            {cta}
          </a>
        </div>
      </div>
    </>
  );
}

export default EventDrivenPagePromotionalBlockCard;
